export const calculateOffScreenPosition = (x, y, containerWidth, containerHeight, resourceColumnWidth) => {
  const PADDING = 10;
  const THRESHOLD_LEFT = 170; // Distance in pixels before showing the indicator on left side
  const THRESHOLD_RIGHT = -190; // Distance in pixels before showing the indicator on right side
  const THRESHOLD_TOP = 100; // Distance in pixels before showing the indicator on top
  const THRESHOLD_BOTTOM = 0; // Distance in pixels before showing the indicator on bottom
  const OFFSET_X = 0;  // Fine-tune X position
  const OFFSET_Y = 0;  // Fine-tune Y position
  
  // Get the header element (same as mouse position calculation)
  const header = document.querySelector('.mbsc-timeline-header-bg.mbsc-flex-1-0.mbsc-flex.mbsc-ios');
  const resources = document.querySelector('.mbsc-timeline-resource-col');
  
  if (!header || !resources) {
    return { x, y, isOffScreen: false };
  }

  const headerRect = header.getBoundingClientRect();
  const resourcesRect = resources.getBoundingClientRect();

  // Create a square box excluding the resources column and header area
  // Width: view width - resource column width (actual calendar content area)
  // Height: view height - header height (actual calendar content area)
  const HEADER_MARGIN = 50; // Extra margin to exclude the full header area (dates + weeks)
  const bounds = {
    left: resourcesRect.width + PADDING,
    right: containerWidth - PADDING,  // view width - resource column width
    top: headerRect.height + PADDING + HEADER_MARGIN,  // Start after header + extra margin
    bottom: containerHeight - PADDING  // view height - header height
  };

  let isOffScreen = false;
  let newX = x;  // Start with current cursor position
  let newY = y;  // Start with current cursor position
  let angle = 0;

  // Calculate distance from boundaries
  const distanceLeft = x - bounds.left;
  const distanceRight = bounds.right - x;
  const distanceTop = y - bounds.top;
  const distanceBottom = bounds.bottom - y;


  // Check if cursor is beyond threshold
  // Handle corners by checking both X and Y distances with different thresholds
  const isLeft = distanceLeft < -THRESHOLD_LEFT;
  const isRight = distanceRight < -THRESHOLD_RIGHT;
  const isTop = distanceTop < -THRESHOLD_TOP;
  const isBottom = distanceBottom < -THRESHOLD_BOTTOM;

  if (isLeft || isRight || isTop || isBottom) {
    isOffScreen = true;
    
    // Handle corners first (when both X and Y are out of bounds)
    if (isLeft && isTop) {
      // Top-left corner
      newX = bounds.left + OFFSET_X;
      newY = bounds.top + OFFSET_Y;
      angle = 315; // Diagonal angle
    } else if (isRight && isTop) {
      // Top-right corner
      newX = bounds.right + OFFSET_X;
      newY = bounds.top + OFFSET_Y;
      angle = 45; // Diagonal angle
    } else if (isLeft && isBottom) {
      // Bottom-left corner
      newX = bounds.left + OFFSET_X;
      newY = bounds.bottom + OFFSET_Y;
      angle = 225; // Diagonal angle
    } else if (isRight && isBottom) {
      // Bottom-right corner
      newX = bounds.right + OFFSET_X;
      newY = bounds.bottom + OFFSET_Y;
      angle = 135; // Diagonal angle
    } else if (isLeft) {
      // Left edge
      newX = bounds.left + OFFSET_X;
      newY = Math.min(Math.max(y + OFFSET_Y, bounds.top), bounds.bottom);
      angle = 270;
    } else if (isRight) {
      // Right edge
      newX = bounds.right + OFFSET_X;
      newY = Math.min(Math.max(y + OFFSET_Y, bounds.top), bounds.bottom);
      angle = 90;
    } else if (isTop) {
      // Top edge
      newY = bounds.top + OFFSET_Y;
      newX = Math.min(Math.max(x + OFFSET_X, bounds.left), bounds.right);
      angle = 0;
    } else if (isBottom) {
      // Bottom edge
      newY = bounds.bottom + OFFSET_Y;
      newX = Math.min(Math.max(x + OFFSET_X, bounds.left), bounds.right);
      angle = 180;
    }
  }


  return {
    x: newX,
    y: newY,
    isOffScreen,
    angle
  };
}; 